<style scoped>
    .demo-drawer-footer{
        width: 400px;
        position: fixed;
        bottom: 0;
        right: 0;
        border-top: 1px solid #e8e8e8;
        padding: 10px 16px;
        text-align: right;
        background: #fff;
    }
    .tablelist{
        border: 1px solid #fff;
        border-collapse: collapse;/* 边框重叠 */
        width:100%;
    }
    .tablelist td{
        border:1px solid #fff;
        height:47px;
        line-height: 47px;
        padding-left:10px;
        padding-right:10px;
        text-align: center;
        font-size: 14px;
        cursor:pointer;
        background:#f2f2f2;
        user-select: none;
    }
    .tablelist td:active,.tablelist td:focus{
        background:#fff;
    }
    .colorPannel {
        height: 30px;
        width: 30px;
        border-radius: 50%;
        display:inline-block;
        margin-left:20px;
    }
</style>
<template>
    <div>

        <Form v-if="sbinfo.status" ref="accountLogin" :model="accountLogin" :rules="ruleValidate">
            <FormItem prop="fenlei">
                <Select v-model="accountLogin.fenlei" label-in-value @on-change="onFlSelect" placeholder="移动此设备至..." style="width:100%">
                    <Option v-for="item in fllist" :value="item.catId" :key="item.catId" >{{ item.catName }}</Option>
                </Select>
            </FormItem>
            <FormItem label="设备名称编辑：" prop="deviceName">
                <Input v-model="accountLogin.deviceName" placeholder="请输入设备名称" style="width: 100%" />
            </FormItem>
        </Form>

        <!--设备状态-->
        <Divider>设备状态</Divider>
        <div >
            <div style="height: 40px">
                <label style="font-size: 13px;text-align: center;">运行状态</label>
                <img src="@/assets/img//ic_broken.png" v-if="!sbinfo.status" style="width:30px;height: 30px;float:right;">
                <img src="@/assets/img//ic_good.png" v-if="sbinfo.status" style="width:30px;height: 30px;float:right;">
            </div>

            <!--时照不显示该字段 20220713-->
            <div v-if="sbinfo.factoryType!=7">
                <div style="height: 40px">
                    <label style="font-size: 13px;text-align: center;">总运行时间</label>
                    <label v-model="runTime" style="font-size: 20px;float:right;">{{getHour(sbinfo.totalRunning)}}h</label>
                </div>
                <div style="height: 40px">
                    <label style="font-size: 13px;text-align: center;">最近运行时长</label>
                    <label v-model="runTime" style="font-size: 20px;float:right;">{{getHour(sbinfo.lastRunning)}}h</label>
                </div>
            </div>
            <div v-if="sbinfo.factoryType==7">
                <div style="height: 40px">
                    <label style="font-size: 13px;text-align: center;">当前状态</label>
                    <label v-model="runTime" style="font-size: 13px;float:right;">{{sbinfo.lampStatusName}}</label>
                </div>
            </div>

        </div>

        <!--灯-->
        <div v-if="sbinfo.factoryType == 3 && sbinfo.status && sbinfo.switch.length > 0 && sbinfo.eid == 'dj'">
            <dl class="tf-cell">
                <dd v-for="(vo,index) in sbinfo.switch" :key="index">
                    <span>开关：</span>
                    <i-switch :disabled="issbSwitch ? true : false" v-model="vo.status" @on-change="jkDjOnChange(vo,index)" />
                </dd>
            </dl>
        </div>

        <!--时照设备-->
        <div v-if="sbinfo.factoryType == 7">
            <dl class="tf-cell">
                <Button style="margin-right: 8px" type="primary" @click="onOffDevice(sbinfo.deviceId,3)">开</Button>
                <Button  type="error" @click="onOffDevice(sbinfo.deviceId,4)">关</Button>
            </dl>
        </div>
        <!--智能面板  晶控 、芯蚁-->
        <div v-if="((sbinfo.factoryType == 3 && sbinfo.eid == 'znmb')
        || ((sbinfo.factoryType == 6 && sbinfo.eid.indexOf('relay') !=-1)) && sbinfo.status && sbinfo.switch.length > 0)">
            <dl class="tf-cell">
                <dd v-for="(vo,index) in sbinfo.switch" :key="index">
                    <span>{{vo.name}}：</span>
                    <i-switch :disabled="issbSwitch ? true : false" v-model="vo.status" @on-change="jkZnmbOnChange(vo,index)" />
                </dd>
            </dl>
        </div>

        <!--摄 像 头-->
        <div v-if="sbinfo.factoryType == 2 && sbinfo.status">
            <video id="myPlayer"  style="width: 100%; height: 350px" controls playsInline webkit-playsinline autoplay>
                <source :src="sbinfo.dinfo.rtmp" type="rtmp/flv" />
                <source :src="sbinfo.dinfo.liveAddress" type="application/x-mpegURL" />
            </video>
            <!--<div style="margin-top: 15px;">-->
            <!--<h2>位置：</h2>-->
            <!--<p style="font-size: 14px; margin-top: 5px;">海淀区龙翔路甲一号泰祥商务楼1号楼左侧监控</p>-->
            <!--<p v-if="!sbinfo.switch" style="font-size: 12px; margin-top: 10px; color: #666;">最后关闭时间：2018-10-12 17:50</p>-->
            <!--</div>-->
            <div style="margin-top: 15px;">
                <Row type="flex" justify="space-between">
                    <Col span="12">
                        <table class="tablelist">
                            <tr>
                                <td @click="changeVideo(4)">左上</td>
                                <td @click="changeVideo(0)">上</td>
                                <td @click="changeVideo(6)">右上</td>
                            </tr>
                            <tr>
                                <td @click="changeVideo(2)">左</td>
                                <td></td>
                                <td @click="changeVideo(3)">右</td>
                            </tr>
                            <tr>
                                <td @click="changeVideo(5)">左下</td>
                                <td @click="changeVideo(1)">下</td>
                                <td @click="changeVideo(7)">右下</td>
                            </tr>
                        </table>
                    </Col>
                    <Col span="12">
                        <table class="tablelist">
                            <tr>
                                <td @click="changeVideo(8)" style="height:71px; line-height: 71px">放大</td>
                                <td @click="changeVideo(9)" style="height:71px; line-height: 71px">缩小</td>
                            </tr>
                            <tr>
                                <td @click="changeVideo(10)" style="height:71px; line-height: 71px">近焦</td>
                                <td @click="changeVideo(11)" style="height:71px; line-height: 71px">远焦</td>
                            </tr>
                        </table>
                    </Col>
                </Row>
            </div>
        </div>
        <!--凯图/芯蚁灯具-->
        <div v-if="(sbinfo.factoryType == 4 || (sbinfo.factoryType == 6 && sbinfo.eid.indexOf('kt') != -1))&& sbinfo.status">
            <Divider v-if="sbinfo.eid.indexOf('kttg') !=-1">调节亮度</Divider>
            <span>渐变值</span>
            <div  >
                <Slider v-model="gradual" :min="0" :max="50" :step="1" show-stops :tip-format="gradualFormat">
                </Slider>
            </div>
            <div v-if="sbinfo.eid.indexOf('kttg') !=-1" v-for="(item,index) in brightnessList" style="width: 100%; height: 100px">
                <div  style="height: 30px;">
                    <label  style="font-size: 14px">调光灯{{index+1}}</label>
                    <i-switch :disabled="issbSwitch ? true : false" v-model="item.status" @on-change="lightSwitchChange(item)" style="float:right;" />
                </div>
                <template>
                    <Slider  v-model="item.brightness" @on-change="tgSliderChange(item)" :min="0" :max="100" :step="10" show-stops :tip-format="tgFormat"></Slider >
                </template>
            </div>

            <div v-if="sbinfo.eid.indexOf('ktts') !=-1" style="width: 100%; height: 450px">
                <Divider>调节颜色</Divider>
                <div style="height: 30px;">
                    <label style="font-size: 14px">调色灯</label>
                    <i-switch :disabled="issbSwitch ? true : false" v-model="rgbLight.status" style="float:right;" @on-change="rgbSwitchChange"/>
                </div>
                <div style="padding-top: 0;margin-top: 10px;height: 40px;width: 100%;">
                    <div class="colorPannel" :style="item" v-for="(item,index) in colors" :key="index"
                         @click="choseColor(item.backgroundColor)"></div>
                </div>
                <div >
                    <span>渐变值</span>
                    <div  >
                        <Slider v-model="gradual" :min="0" :max="50" :step="1" show-stops :tip-format="gradualFormat">
                        </Slider>
                    </div>
                    <span>R</span>
                    <div  >
                        <Slider v-model="rgbLight.r" :min="0" :max="100" :tip-format="tsFormat" @on-change="sliderChange">
                        </Slider>
                    </div>

                    <span>G</span>
                    <div >
                        <Slider v-model="rgbLight.g"  :min="0" :max="100" :tip-format="tsFormat" @on-change="sliderChange">
                        </Slider>
                    </div>

                    <span>B</span>
                    <div >
                        <Slider v-model="rgbLight.b" :min="0" :max="100" :tip-format="tsFormat" @on-change="sliderChange">
                        </Slider>
                    </div>

                    <span>W</span>
                    <div >
                        <Slider v-model="rgbLight.w" :min="0" :max="100" :tip-format="tsFormat" @on-change="sliderChange">
                        </Slider>
                    </div>
                    <!--补充显示-->
                    <!--<div style="height: 30px;line-height:30px;padding-top: 0;margin-top: 10px;margin-bottom: 10px">-->
                    <!--效果预览：<div class="colorPannel"  :style="{'backgroundColor': curColors}" style="float:right;"></div>-->
                    <!--</div>-->
                    <!--色盘-->
                    <div class="block" style="margin-bottom: 10px">
                        <span >色盘：</span>
                        <color-picker v-model="curColors" @on-change="colorPickerChange" style="margin-left:80px;"></color-picker>
                        <Button type="primary" @click="colorSave" style="float:right;">保存当前颜色</Button>
                    </div>
                    <span >喜欢的颜色：</span>
                    <div style="padding-top: 0;margin-top: 10px;height: 40px;width: 100%;">
                        <div class="colorPannel" :style="{'backgroundColor': item.color}" v-for="(item,index) in colorList" :key="index"
                             @click="choseColor(item.color)"></div>
                    </div>
                </div>

             </div>
        </div>
        <!--天正传感器-->
        <!--水位传感器-->
        <div v-if="sbinfo.factoryType == 1 && $store.state.app.tz.eid.sw.indexOf(sbinfo.eid) !== -1 && sbinfo.status">
            <Divider>传感器数据</Divider>
            <dl class="tf-cell">
                <dd><span>当前水位：</span>{{sbinfo.eqmsg}}m</dd>
            </dl>
        </div>

        <!--温湿度传感器-->
        <div v-if="sbinfo.factoryType == 1 && $store.state.app.tz.eid.wsd.indexOf(sbinfo.eid) !== -1 && sbinfo.status">
            <Divider>传感器数据</Divider>
            <dl class="tf-cell">
                <dd><span>当前温度：</span>{{sbinfo.eqmsg.split(',')[1]}}℃</dd>
                <dd><span>当前湿度：</span>{{Number(Number(sbinfo.eqmsg.split(',')[0]*100).toFixed(8))}}%RH</dd>
            </dl>
        </div>

        <!--温湿盐传感器-->
        <div v-if="sbinfo.factoryType == 1 && $store.state.app.tz.eid.wsy.indexOf(sbinfo.eid) !== -1 && sbinfo.status">
            <Divider>传感器数据</Divider>
            <dl class="tf-cell">
                <dd><span>当前温度：</span>{{sbinfo.eqmsg.split(',')[1]}}℃</dd>
                <dd><span>当前湿度：</span>{{Number(Number(sbinfo.eqmsg.split(',')[0]*100).toFixed(8))}}%RH</dd>
                <dd><span>当前盐度：</span>{{sbinfo.eqmsg.split(',')[2]}}us/cm</dd>
            </dl>
        </div>

        <!--精讯传感器-->
        <div v-if="sbinfo.factoryType == 5 && sbinfo.status && $func.isSensor(sbinfo.eid)">
            <Divider>传感器数据</Divider>
            <dl class="tf-cell">
                <dd><span>{{sbinfo.eqmsg.name}}：</span>{{sbinfo.eqmsg.value}}  {{sbinfo.eqmsg.union}}</dd>
            </dl>
        </div>
        <!--精讯继电器-->
        <div v-if="sbinfo.factoryType == 5 && sbinfo.status && $func.isRelay(sbinfo.eid) && sbinfo.switch.length > 0">
            <dl class="tf-cell">
                <dd v-for="(vo,index) in sbinfo.switch" :key="index">
                    <span>{{vo.name}}：</span>
                    <i-switch :disabled="issbSwitch ? true : false" v-model="vo.status" @on-change="jkZnmbOnChange(vo,index)" />
                </dd>
            </dl>
        </div>
        <!--芯蚁传感器-->
        <div v-if="sbinfo.factoryType == 6 && sbinfo.status && $func.isSensor(sbinfo.eid)">
            <Divider>传感器数据</Divider>
            <dl class="tf-cell">
                <dd v-for="(vo,index) in sbinfo.eqmsg" :key="index">
                    <span>{{vo.name}}：</span>{{vo.value}}  {{vo.union}}</dd>
            </dl>
        </div>

        <!--只有天正设备显示设备详情-->
        <Divider v-if="sbinfo.factoryType == 1">设备详情</Divider>
        <dl v-if="sbinfo.factoryType == 1" class="tf-cell">
            <!--判断是否双控电磁阀-->
            <dd v-if="sbinfo.status" v-for="(vo,index) in sbinfo.switch" :key="index">
                <span>{{vo.name}}开关：</span>
                <i-switch :disabled="issbSwitch ? true : false" v-model="vo.status" @on-change="jkZnmbOnChange(vo,index)" />
            </dd>
            <dd><span>设备名称：</span>{{sbinfo.deviceName ? sbinfo.deviceName : 'N/A'}}</dd>
            <dd><span>设备类型：</span>{{sbinfo.catName ? sbinfo.catName : 'N/A'}}</dd>
            <dd><span>设备ID：</span>{{sbinfo.deviceId ? sbinfo.deviceId : 'N/A'}}</dd>
            <dd><span>设备mac地址：</span>{{sbinfo.deviceMac ? sbinfo.deviceMac : 'N/A'}}</dd>
            <dd><span>网关mac地址：</span>{{sbinfo.netMac ? sbinfo.netMac : 'N/A'}}</dd>
        </dl>

        <!--其他设备详情-->
        <Divider v-if="sbinfo.factoryType != 1">设备详情</Divider>
        <dl v-if="sbinfo.factoryType != 1" class="tf-cell">
            <dd><span>设备名称：</span>{{sbinfo.deviceName ? sbinfo.deviceName : 'N/A'}}</dd>
            <dd><span>设备类型：</span>{{sbinfo.catName ? sbinfo.catName : 'N/A'}}</dd>
            <dd><span>设备ID：</span>{{sbinfo.deviceId ? sbinfo.deviceId : 'N/A'}}</dd>
        </dl>

        <!--按钮-->
        <div class="demo-drawer-footer">
            <Button style="margin-right: 8px" @click="onCancel">取消</Button>
            <Button style="margin-right: 8px" type="error" @click="onDel">删除设备</Button>
            <Button v-if="sbinfo.status" type="primary" @click="onSubmit">确定</Button>
        </div>
    </div>
</template>

<script>
    import xl from '@/assets/img/lx/xl.png';

    export default {
        props: ['sbinfo'],

        data() {
            return {
                xl:xl,

                src:'',

                fllist:[],

                list: [],

                //定时
                csTime:0,

                //设备开关
                issbSwitch:false,

                // 设备详情
                con:'',

                //表单
                accountLogin: {
                    fenlei: '',
                    deviceName:this.sbinfo.deviceName || ''
                },
                ruleValidate: {
                    deviceName: [
                        { required: true, message: '设备名称不能为空', trigger: 'blur' }
                    ],
                },

                //摄像头操控
                isSxtControll:true,
                domain:{
                    domainName:'',
                    hostIp:'',
                },
                brightnessList: [
                    {port: 5, brightness: 0, status: true},
                    {port: 6, brightness: 0, status: true},
                    {port: 7, brightness: 0, status: true},
                    {port: 8, brightness: 0, status: true},
                ],// 4路灯 只有四个
                colors: [
                    {backgroundColor: '#FF0000'},
                    {backgroundColor: '#FF7F00'},
                    {backgroundColor: '#FFFF00'},
                    {backgroundColor: '#00FF00'},
                    {backgroundColor: '#00FFFF'},
//                    {backgroundColor: '#0000FF'},
                    {backgroundColor: '#8B00FF'},
                ],
                curColors: '#000000',
                gradual:3,
                rgbLight: {r: 0, g: 0, b: 0,w:0, status: 0, text: "调色灯"},
                runTime: 0,// 连续运行时间
                //调色灯颜色存储参数
                kttsColor: {
                    custColorId:'',
                    color: '',
                    w: '',
                },
                colorList:[],
            };
        },
        computed: {
            //接收socket消息
            wsMessage() {
                return this.$store.state.app.wsMessage;
            }
        },
        watch:{
            //监控并且格式化socket消息
            wsMessage(r){
                const that = this;
                // if(that.sbinfo.deviceMac == r.emac)
                // {
                that.getInfo();
                clearTimeout(that.csDsq);
                that.$emit("refresh");
                that.$Message.destroy()
                // that.$func.msg('操作成功')
                //启用点击按钮
                that.issbSwitch = false;
                // }
            },
            //实时监听curColor  变动一次 提交一次
            curColors(){
                this.sliderChange();
            },
        },
        created(){
            var that = this;
            that.getCategory();
            that.getInfo();
            console.log(that.sbinfo.factoryType);
            console.log(that.sbinfo.status);
            console.log(that.sbinfo.netMac);
            console.log(that.sbinfo.eid);
            console.log(that.sbinfo.eqmsg);
            console.log(that.sbinfo.switch);
            console.log(that.sbinfo.switchNum);


//            if((that.sbinfo.factoryType == 4 || (that.sbinfo.factoryType == 6 && that.sbinfo.eid.indexOf('kt') != -1))&& that.sbinfo.status){//凯图、芯蚁灯具
//                that.domain.domainName=that.sbinfo.netMac;
//                that.domain.hostIp=that.sbinfo.deviceMac;
//                that.getLightBrightness();
//                that.getKttsColor();
//            }else if(that.sbinfo.eid.indexOf('music') != -1) {//音乐
//
//            }
//            that.getDeviceDetail();

            //判断摄像头状态
            if(that.sbinfo.factoryType == 2 && that.sbinfo.status){
                // status	int	地址使用状态：0-未使用或直播已关闭，1-使用中，2-已过期，3-直播已暂停，0状态不返回地址，其他返回
                // exception	int	地址异常状态：0-正常，1-设备不在线，2-设备开启视频加密，3-设备删除，4-失效，5-未绑定，6-账户下流量已超出，7-设备接入限制，0/1/2/6状态返回地址，其他不返回
                //判断
                switch (that.sbinfo.dinfo.status) {
                    case 0:that.$func.msg('未使用或直播已关闭','error');break;
                    case 2:that.$func.msg('未使用或直播已关闭','error');break;
                    case 3:that.$func.msg('直播已暂停','error');break;
                }
                switch (that.sbinfo.dinfo.exception) {
                    case 1:that.$func.msg('设备不在线','error');break;
                    case 3:that.$func.msg('设备已在萤石删除','error');break;
                    case 4:that.$func.msg('失效','error');break;
                    case 5:that.$func.msg('未绑定','error');break;
                    case 6:that.$func.msg('账户下流量已超出','error');break;
                    case 7:that.$func.msg('设备接入限制','error');break;
                }
            }
        },
        methods: {
            getHour(sec) {
                if (sec <=0) return 0;
                return (sec / 60 / 60).toFixed(2); // 保留两位小数

            },
            //获取调色灯颜色记录
            getKttsColor(){
                const that = this;
                that.$func.ajax('getKttsColor', {}, function (r) {
                    if (r.statusCode) {//有记录
                        that.colorList = r.type;
//                        console.log('获取调色灯颜色记录'+r.type);
                    }
                });
            },
            //保存调色灯颜色
            colorSave(){
                const that = this;
                if(that.colorList.length >= 6){//超过6个
                    var newVal = '';
                    that.$Modal.confirm({
                        title: '预留位已满，当前颜色将替换第几个颜色？',
                        render: (h) => {
                            return h('Input', {
                                props: {
                                    value: name,
                                    autofocus: true,
                                    placeholder: '请输入对应的数字，从左到右依次是1-6',
                                    maxlength: 10
                                },
                                on: {
                                    input: (val) => {
                                        newVal = val
                                    }
                                }
                            })
                        },
                        onOk: () => {
                            var re = new RegExp(/^[1-6]$/);
                            if(!re.test(newVal)) {
                                this.$Message.error('输入的数据不正确');
                                return
                            }
                            that.kttsColor=that.colorList[newVal-1];
                            that.kttsColorSave();
                        }
                    })
                }else{
                    that.kttsColorSave();
                }
            },
            kttsColorSave(){
                const that = this;
                that.kttsColor.color=that.curColors;
                that.kttsColor.w=that.rgbLight.w;
                that.$func.ajax('kttsColorSave', that.kttsColor, function (r) {
                    if (!r.statusCode) {
                        that.$func.msg(r.message, 'error');
                    } else {
                        that.$Message.success('保存成功');
                        that.getKttsColor();
                    }
                })
            },
            getInervalHour(startDate, endDate) {
                var ms = endDate.getTime() - startDate.getTime();
                if (ms < 0) return 0;
                return (ms / 2000 / 60 / 60).toFixed(1); // 保留一位小数
            },
            tgFormat (val) {
                return '亮度' + val + '%';
            },
            gradualFormat (val) {
                return '渐变值' + val + '%';
            },
            tsFormat (val) {
                return val + '%';
            },
            sliderChange(val){
                console.log(JSON.stringify(val))
                this.curColors=this.$KtApi.toColorHex(parseInt(this.rgbLight.r/100*255),
                    parseInt(this.rgbLight.g/100*255),parseInt(this.rgbLight.b/100*255));
                console.log('保存灯光配置：' + this.curColors);
                if(this.rgbLight.r+this.rgbLight.g+this.rgbLight.b+this.rgbLight.w != 0 && this.rgbLight.status==false){
                    this.rgbLight.status=true
                    this.$emit("refresh");
                }else if(this.rgbLight.r+this.rgbLight.g+this.rgbLight.b+this.rgbLight.w == 0 && this.rgbLight.status==true){
                    this.rgbLight.status=false
                    this.$emit("refresh");
                };
                this.save();
            },
            /**
             * 色盘选择  更新到滑条
             */
            colorPickerChange(){
                this.toSlider(this.curColors)
            },
            // 转换显示到滑条
            toSlider(color){
                this.curColors = color;
                var arr = this.$KtApi.toColorPercentArr(color)
                this.rgbLight.r = arr[0];
                this.rgbLight.g = arr[1];
                this.rgbLight.b = arr[2];
            },

            // 开关接口
            onOffDevice(deviceId,operateType){
                var that=this;
                that.$func.ajax('operateDevice', {
                    mobileId:that.$func.getToken(),
                    deviceNo: deviceId,
                    operateType:operateType,
                }, function (r) {
                    if (!r.statusCode) {
                        that.$func.msg(r.message);
                    }else{
                        that.$func.msg('操作成功');
                    }
                })
            },
            //色灯开关
            rgbSwitchChange(val){
                const that = this;
                that.$Message.loading({
                    content: '操作中...',
                    duration: 0
                });
                if (val==false){
                    //调用后台控制设备，一键关
                    that.$func.ajax('operateDevice', {
                        mobileId:that.$func.getToken(),
                        deviceNo: that.sbinfo.deviceId,
                        operateType:4,
                    }, function (r) {
                        if (!r.statusCode) {
                            that.$func.msg(r.message);
                        }else{
                            that.$func.msg('操作成功');
                            // 更新滑条
                            that.toSlider('#000000')
                            that.rgbLight.w=0;
                        }
                    })


                }else{
                    //调用后台控制设备，一键开
                    that.$func.ajax('operateDevice', {
                        mobileId:that.$func.getToken(),
                        deviceNo: that.sbinfo.deviceId,
                        operateType:3,
                    }, function (r) {
                        if (!r.statusCode) {
                            that.$func.msg(r.message);
                        } else {
                            that.$func.msg('操作成功');
                            ///开启时获取色值
                            that.getLightBrightness();
                        }
                    })
                }
                setTimeout(function(){//10秒后刷新上一页
                    that.$Message.destroy();
                    that.$emit("refresh");
                    //启用点击按钮
                    that.issbSwitch = false;
                },2000)
            },
            choseColor(color){
                // 要用字符串，否则会整个引用过来
//                this.curColors=item;
                this.toSlider(color);
                console.log(JSON.stringify(color));
            },
            //调光开关
            lightSwitchChange(item){
                if (item.status){
                    this.turnOnByPort(item.port)
                }else {
                    this.turnOffByPort(item.port)
                }
            },
            tgSliderChange(item){
                const that = this;
                var port=item.port
                if (!item.status){//关闭状态
                    that.$Message.loading({
                        content: '操作中...',
                        duration: 0
                    });
                    //调用后台控制设备，单路开
                    that.$func.ajax('operateDevice', {
                        mobileId:that.$func.getToken(),
                        deviceNo: that.sbinfo.deviceId,
                        command:{port:port},
                        operateType: 2
                    }, function (r) {
                        if (!r.statusCode) {
                            that.$func.msg(r.message);
                            that.$Message.destroy();
                        } else {
                            that.$func.msg('操作成功');
                            that.$Message.destroy();
                            that.refreshInfo(that.sbinfo.deviceId);
                            setTimeout(function () {
                                that.$emit("refresh");
                                //启用点击按钮
                                that.issbSwitch = false;
                            },2000)

                        }
                    })

                }else{
                    if(item.brightness<1){
                        item.status=false;
                        that.$emit("refresh");
                    }
                    console.log('检测到亮度变化，端口' + port)
                    this.save(item);
                }

            },
            //强电开、调光开
            turnOnByPort(port){
                const that = this;
                that.$Message.loading({
                    content: '操作中...',
                    duration: 0
                });
                //调用后台控制设备，单路开
                that.$func.ajax('operateDevice', {
                    mobileId:that.$func.getToken(),
                    deviceNo: that.sbinfo.deviceId,
                    command:{port:port},
                    operateType: 2
                }, function (r) {
                    if (!r.statusCode) {
                        that.$func.msg(r.message);
                        that.$Message.destroy();
                    } else {
                        that.$func.msg('操作成功');
                        //开启时获取亮度
                        that.getLightBrightness();
                        that.$Message.destroy();
                        that.refreshInfo(that.sbinfo.deviceId);
                        setTimeout(function () {
                            that.$emit("refresh");
                            //启用点击按钮
                            that.issbSwitch = false;
                        },2000)
                    }
                })

            },
            //强电关、调光关
            turnOffByPort(port){
                const that = this;
                that.$Message.loading({
                    content: '操作中...',
                    duration: 0
                });
                //调用后台控制设备，单路关
                that.$func.ajax('operateDevice', {
                    mobileId:that.$func.getToken(),
                    deviceNo: that.sbinfo.deviceId,
                    command:{port:port},
                    operateType: 1
                }, function (r) {
                    if (!r.statusCode) {
                        that.$func.msg(r.message);
                        that.$Message.destroy();
                    } else {
                        that.$func.msg('操作成功');
                        that.$Message.destroy();
                        that.refreshInfo(that.sbinfo.deviceId);
                        setTimeout(function () {
                            that.$emit("refresh");
                            //启用点击按钮
                            that.issbSwitch = false;
                        },2000)
                    }
                })
            },
            //芯蚁状态查询
            getXyInfo(){
                var that = this;
                that.$func.ajax('refreshInfo', {
                    token: that.$func.getToken(),
                    deviceNo: that.sbinfo.deviceId
                }, function (r) {
                    if (r.statusCode) {//成功
                        console.log('查询来了');
                        console.log(that.sbinfo.eid);
                        console.log(that.sbinfo.isGroup);
                        console.log(that.sbinfo.isGroup==0);
                        that.sbinfo.status = true;
                        if(that.$func.isRelay(that.sbinfo.eid) || that.sbinfo.eid.indexOf('valve') != -1) {//继电器、电磁阀
                            if(that.sbinfo.isGroup==0){//单个设备
                                //按钮名称
                                var remarkArr = that.sbinfo.remark.split('\r\n');
                                //判断设备
                                var lens = remarkArr.length;
                                console.log(lens);
                                //判断开关
                                that.sbinfo.switchNum = lens;
                                var status=[];
                                //反编译开关
                                var lensswitchs = [];
                                if(lens==1){
                                    lensswitchs.push({
                                        name: remarkArr[0],
                                        value: '',
                                        status:  r.type.info.isOpen==1?true:false
                                    })
                                }else{
                                    for (let ii = 0; ii < lens; ii++) {
                                        lensswitchs.push({
                                            name: remarkArr[ii],
                                            value: '',
                                            status:  r.type.info.switchArr[ii]
                                        })
                                    }
                                }
                                that.sbinfo.switch = lensswitchs;
                            }else {//组合设备

                            }
                        }else if(that.sbinfo.eid.indexOf('sensor') != -1) {//传感器
                            var eqmsg=that.$func.sensorData(that.sbinfo.eid,6);
                            eqmsg.map(function (vv, ii) {
                                eqmsg[ii].value=r.type.info.value.split(',')[ii];
                            });
                            that.sbinfo.eqmsg = eqmsg;//数组
                        }else if(that.sbinfo.eid.indexOf('kt') != -1){//芯蚁灯具
                            that.gradual=r.type.info.fadeTime;
                            if(that.sbinfo.eid.indexOf('ktts')!= -1){//调色
                                that.rgbLight.r = r.type.info.r;
                                that.rgbLight.g = r.type.info.g;
                                that.rgbLight.b = r.type.info.b;
                                that.rgbLight.w = r.type.info.w;
                                that.curColors = that.$KtApi.toColorHex(parseInt(that.rgbLight.r/100*255),
                                    parseInt(that.rgbLight.g/100*255),parseInt(that.rgbLight.b/100*255));
                                if (that.curColors=='#000000'&&that.rgbLight.w<1){
                                    that.rgbLight.status=false
                                }else {
                                    that.rgbLight.status=true
                                }
                            }else  if(that.sbinfo.eid.indexOf('kttg-1')!= -1||that.sbinfo.isGroup==1){//简化调光
                                that. brightnessList=[
                                    {port: 1, brightness: r.type.info.brightness1, status: r.type.info.brightness1>0?true:false},
                                ]
                            }else  if(that.sbinfo.eid.indexOf('kttg-2')!= -1){//全功能调光
                                that. brightnessList=[
                                    {port: 1, brightness: r.type.info.brightness1, status: r.type.info.brightness1>0?true:false},
                                    {port: 2, brightness: r.type.info.brightness2, status: r.type.info.brightness2>0?true:false},
                                ]
                            }
                            console.log('调光灯查询更新：' + JSON.stringify(that.brightnessList))
                        }else if(that.sbinfo.eid.indexOf('music') != -1) {//音乐

                        }else if (that.sbinfo.eid.indexOf('lamp') != -1){
//                            that.item.isOpen =r.type.lampStatusName==1
                            that.sbinfo.status=true
                            that.sbinfo.lampStatusName = r.type.lampStatusName.replace('灯','设备');

                        }
                        that.$forceUpdate();
                    } else {//离线
                        that.$func.msg(r.message);
                    }
                }, function (err) {
                    that.$func.msg(err)
                })

            },
            // 凯图灯查询当前状态
            getLightBrightness(){
                var that = this;
                if (this.sbinfo.eid.indexOf('kttg')!=-1) {
                    console.log("调光灯查询")
                    that.$KtApi.getBrightness(that.$KtApi.getIdByEid(this.sbinfo.eid),that.domain, function (msg) {
                        that.brightnessList=msg.bright
                        console.log('调光灯查询更新：'+JSON.stringify(that.brightnessList))
                    }, function (err) {
                        that.$func.msg(err)
                    })
                } else if (this.sbinfo.eid.indexOf('ktts')!=-1) {
                    console.log("调色灯查询")
                    var that=this;
                    that.$KtApi.getBrightness(that.$KtApi.getIdByEid(this.sbinfo.eid),that.domain, function (msg) {
                        console.log(JSON.stringify(msg))
                        that.toSlider(msg.color)
                        that.rgbLight.w = msg.bright[3].brightness;
                        if (msg.color=='#000000'&&that.rgbLight.w<1){
                            that.rgbLight.status=false
                        }else {
                            that.rgbLight.status=true
                        }
                    }, function (err) {
                        that.$func.msg(err)
                    })

                }
            },
            save(item){
                const that = this;
                // 调光 发送4条或对比改动后再发
                if (this.$KtApi.isSetBright(this.sbinfo.eid)) {
                    console.log(JSON.stringify(this.brightnessList));
                    // 根据端口
                    var com={ port:item.port, brightness:item.brightness,gradual:that.gradual};
                    //调用后台控制设备
                    that.$func.ajax('operateDevice', {
                        mobileId:that.$func.getToken(),
                        deviceNo: that.sbinfo.deviceId,
                        command: com,
                        operateType: 6
                    }, function (r) {
                        if (!r.statusCode) {
                            that.$func.msg(r.message);
                        } else {
                            that.$func.msg('操作成功');
                        }
                    })

                } else if (this.$KtApi.isSetColor(this.sbinfo.eid)) {
                    var com={ color:that.curColors,w:that.rgbLight.w,gradual:that.gradual};
                    //调用后台控制设备
                    that.$func.ajax('operateDevice', {
                        mobileId:that.$func.getToken(),
                        deviceNo: that.sbinfo.deviceId,
                        command: com,
                        operateType: 5
                    }, function (r) {
                        if (!r.statusCode) {
                            that.$func.msg(r.message);
                        } else {
                            that.$func.msg('操作成功');
                        }
                    })

                }

            },
            //分类移动
            onFlSelect(val){
                const that = this;
                that.$func.ajax('customerDeviceCatUpdate',{
                    catId:val.value,
                    custDeviceId:that.sbinfo.deviceId,
                    token:that.$func.getToken()
                },function(r){
                    if(!r.statusCode){
                        that.$func.msg(r.message,'error');
                    }else{
                        that.$func.msg('移动成功');
                        that.getInfo();
                        that.$emit("refresh");
                    }
                })
            },
            getCategory(){
                const that = this;
                that.$func.ajax('catList',{
                    catPosition:3,
                    token:that.$func.getToken()
                },function(r){
                    if(!r.statusCode){
                        that.$func.msg(r.message,'error');
                    }else{
                        console.log(r.type);
                        that.fllist = r.type;
                    }
                })
            },
            //控制摄像头云台
            changeVideo(index){
                const that = this;
                // if(that.isSxtControll){
                    that.isSxtControll = false;
                    that.$func.ys.controllDevice(index,that.sbinfo.deviceMac,function () {
                        that.isSxtControll = true;
                    },function () {
                        that.isSxtControll = true;
                    },function () {
                        that.isSxtControll = true;
                    });
                // }
            },
            //晶控灯具开关设备
            jkDjOnChange(val)
            {
                const that = this;
                that.$Message.loading({
                    content: '操作中...',
                    duration: 0
                });
                //调用后台控制设备，一键开/关
                that.$func.ajax('operateDevice', {
                    mobileId:that.$func.getToken(),
                    deviceNo: that.sbinfo.deviceId,
                    operateType: val.status ? 3:4
                }, function (r) {
                    if (!r.statusCode) {
                        that.$func.msg(r.message);
                        that.$Message.destroy();
                    } else {
                        that.$func.msg('操作成功');
                        that.$Message.destroy();
                        that.refreshInfo(that.sbinfo.deviceId);
                        setTimeout(function () {
                            that.$emit("refresh");
                            //启用点击按钮
                            that.issbSwitch = false;
                        },2000)
                    }
                })
            },
            //晶控智能面板开关设备
            jkZnmbOnChange(val,index){
                const that = this;
                that.$Message.loading({
                    content: '操作中...',
                    duration: 0
                });
                //调用后台控制设备，单路开/关
                that.$func.ajax('operateDevice', {
                    mobileId: that.$func.getToken(),
                    deviceNo: that.sbinfo.deviceId,
                    command: index + 1,
                    operateType: val.status ? 2 : 1
                }, function (r) {
                    if (!r.statusCode) {
                        that.$func.msg(r.message);
                        that.$Message.destroy();
                    } else {
                        that.$func.msg('操作成功');
                        that.$Message.destroy();
                        that.refreshInfo(that.sbinfo.deviceId);
                        setTimeout(function () {
                            that.$emit("refresh");
                            //启用点击按钮
                            that.issbSwitch = false;
                        },2000)
                    }
                })
            },
            refreshInfo(deviceId){
                const that = this;
                that.$func.ajax('refreshInfo', {
                    token: that.$func.getToken(),
                    deviceNo: deviceId
                }, function (r) {

                }, function (err) {
                    that.$func.msg(err)
                })
            },
            getInfo(){
                const that = this;
                if(that.sbinfo.factoryType == 1) //天正
                {
                }else if(that.sbinfo.factoryType == 2) //萤石
                {
                    console.log('萤石');
                }else if(that.sbinfo.factoryType == 3) //晶控
                {
                    console.log('晶控');
                }else if(that.sbinfo.factoryType == 4) //凯图
                {
                    console.log('凯图');
                    that.domain.domainName=that.sbinfo.netMac;
                    that.domain.hostIp=that.sbinfo.deviceMac;
                    that.getLightBrightness();
                    that.getKttsColor();
                }else if(that.sbinfo.factoryType == 5) //精讯
                {
                    console.log('精讯');
                }else if(that.sbinfo.factoryType == 6) //芯蚁
                {
                    console.log('芯蚁');
                    if(that.sbinfo.eid.indexOf('kt') != -1){//芯蚁灯具
                        that.getKttsColor();
                    }
                    that.getXyInfo();
                }else if(that.sbinfo.factoryType == 7||that.sbinfo.factoryType == 9) //时照 和风
                {
                    console.log('时照和风');
                    that.getXyInfo();
                }

            },
            onDel(){
                const that = this;
                that.$Modal.confirm({
                    title: '确定删除设备吗？',
                    content: '设备删除后无法回撤，请您知晓！',
                    onOk: () => {
                        that.$func.ajax('customerDeviceDel',{
                            deviceNo:that.sbinfo.deviceId,
                            token:that.$func.getToken()
                        },function(r){
                            if(!r.statusCode){
                                that.$func.msg(r.message,'error');
                            }else{
                                that.$emit("refresh");
                                that.$func.msg('删除成功');
                                that.onCancel();
                            }
                        })
                    }
                });
            },
            onCancel(){
                this.src = "";
                this.$emit('close');
            },
            onSubmit(){
                const that = this;
                //验证表单
                that.$refs['accountLogin'].validate(valid => {
                    if (valid)
                    {
                        that.$func.ajax('customerDeviceNameUpdate',
                        {
                            token:that.$func.getToken(),
                            custDeviceId:that.sbinfo.deviceId,
                            deviceName:that.accountLogin.deviceName
                        },function(r){
                            if(!r.statusCode){
                                that.$func.msg(r.message,'error');
                            }else{
                                that.$emit("refresh");
                                that.$func.msg('修改成功！');
                                that.onCancel();
                            }
                        })
                    }
                });
            }
        },
        mounted()
        {
            if(this.sbinfo.factoryType == 2){
                new EZUIPlayer('myPlayer');
            }
        },
        //离开当前页面后执行
//        destroyed: function () {
//            this.$emit("refresh");
//        },
    };
</script>